
import { defineComponent, SetupContext, onMounted, ref, computed } from "vue";
import {
  PantryFridgeAreaImageData,
  PantryFridgeRoomData,
  FREEZER_AREA_ID_TYPE,
  FridgeCameraRoomInfo
} from "@/types/pantry";
import store from "@/store";
import PantryImageRoomItem from "./PantryImageRoomItem.vue";
import PantryImageEmptyView from "./PantryImageEmptyView.vue";
import NativeClient from "@/client/native-client";
import PantryUtil from "@/utils/pantry-util";
import CommonUtil from "@/utils/common-utils";
export default defineComponent({
  name: "PantryImageRoomFrizzerView",
  components: {
    PantryImageRoomItem,
    PantryImageEmptyView
  },
  props: {
    roomId: {
      type: Number,
      defalut: -1
    },
    room: {
      type: PantryFridgeRoomData,
      default: null
    },
    imageUpdate: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false,
      required: true
    },
    applianceId: {
      type: String,
      default: null,
      required: true
    },
    cameraRoomInfo: {
      type: FridgeCameraRoomInfo,
      default: null,
      required: true
    },
  },
  setup(props, context: SetupContext) {
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value >= 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };
    const getImages = () => {
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView getImages roomId=" + props.roomId + " room=" + CommonUtil.jsonStringify(props.room));
      const imageList = new Array<PantryFridgeAreaImageData>();
      if (props.room) {
        let image = null;
        const areaIdList = PantryUtil.getAreaIdList(props.room.roomId, -1);
        if (areaIdList != null) {
          for (const key of areaIdList) {
            switch (key) {
              case FREEZER_AREA_ID_TYPE.UPPER_TRAY:
              case FREEZER_AREA_ID_TYPE.MEDIAM_TRAY:
              case FREEZER_AREA_ID_TYPE.LOWER_TRAY:
                image = props.room.areaMap.get(key);
                if (image != null) {
                  imageList.push(image);
                }
                break;
            }
          }
        }
      }
      return imageList;
    };
    const getHorizontalImages = () => {
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView getHorizontalImages roomId=" + props.roomId);
      const imageList = new Array<PantryFridgeAreaImageData>();
      if (props.room) {
        let image = null;
        const areaIdList = PantryUtil.getAreaIdList(props.room.roomId, -1);
        if (areaIdList != null) {
          for (const key of areaIdList) {
            switch (key) {
              case FREEZER_AREA_ID_TYPE.UPPER_LEFT_TRAY:
              case FREEZER_AREA_ID_TYPE.UPPER_RIGHT_TRAY:
                image = props.room.areaMap.get(key);
                if (image != null) {
                  imageList.push(image);
                }
                break;
            }
          }
        }
      }
      return imageList;
    }
    const onSelectImage = (roomId: number, areaId: number, fileName: string) => {
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView onSelectImage");
      context.emit("select-image", roomId, areaId, fileName);
    };
    const isEmpty = () => {
      const result = props.room && props.room.areaMap.size == 0;
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView isEmpty roomId=" + props.roomId + " result=" + result);
      return result;
    };
    const isNoData = () => {
      const result = props.room == null;
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView isNoData roomId=" + props.roomId + " result=" + result );
      return result;
    };
    const getSize = () => {
      const result = props.room ? props.room.areaMap.size : 0;
      return result;
    };
    const completeLoadCamaraImage = (roomId: number) => {
      store.dispatch("common/stopLoading");
      updateDisplay();
    };
    const setFridgeImageUrlList = async (roomId: number, applianceId: string) => {
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView setFridgeImageUrlList applianceId=" + applianceId + " roomId=" + roomId);
      const fridgeRoomId = PantryUtil.getFridgeRoomId(roomId);
      const success = PantryUtil.setFridgeImageUrlListMap(roomId, fridgeRoomId, applianceId);
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView setFridgeImageUrlList applianceId=" + applianceId + " roomId=" + roomId + " success=" + success);
      if (success) {
        const images = props.room.getImageList();
        PantryUtil.requestImageLoad(roomId, images, applianceId, completeLoadCamaraImage);
      } else {
        store.dispatch("common/stopLoading");
      }
    };
    const requestFridgeListResult = async (roomId: number, applianceId: string) => {
      setFridgeImageUrlList(roomId, applianceId);
    };
    const requestFridgeListParamResult = async (roomId: number, applianceId: string) => {
      PantryUtil.requestFridgeList(roomId, applianceId, requestFridgeListResult);
    };
    const execute = async () => {
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView execute roomId=" + props.roomId);
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView execute isSelect=" + props.isSelect);
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView execute room=" + CommonUtil.jsonStringify(props));
      NativeClient.sendDebugLog("PantryImageRoomFrizzerView execute applianceId=" + props.applianceId);
      if (props.room && props.isSelect && props.roomId != undefined) {
        const images = props.room.getImageList();
        NativeClient.sendDebugLog("PantryImageRoomFrizzerView execute");
        const isCompelete = PantryUtil.isCompeleteLoadImageData(images);
        NativeClient.sendDebugLog("PantryImageRoomFrizzerView execute isCompelete=" + isCompelete);
        if (!isCompelete) {
          store.dispatch("common/startLoading");
          PantryUtil.requestFridgeListParam(props.roomId, props.applianceId, requestFridgeListParamResult)
        }
      }
    };

    const onShowDate = (roomId:number, areaId: number) => {
      const selectId = PantryUtil.getSelectId(roomId, areaId, props.room);
      const dateList = PantryUtil.getDateList(roomId, areaId, props.room);
      if (selectId != -1 && dateList.length != 0) {
        context.emit("show-date", roomId, areaId, selectId, dateList);
      }
    };

    const isShowHorizontal = () => {
      return props.cameraRoomInfo.isUmamori;
    };

    const styleRoomImageView = computed(() => {
      const marginTop = isShowHorizontal() ?
          "0rem" : "auto";
      return { 'marginTop': marginTop };
    });
    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });
    return {
      getImages,
      getHorizontalImages,
      onSelectImage,
      isEmpty,
      isNoData,
      getSize,
      updateDisplayKey,
      onShowDate,
      isShowHorizontal,
      styleRoomImageView
    }
  }
});
